import { logger } from 'common-ui';
import { fetchCart } from './fetchCart';
import type { AuthDetails } from 'tsconfig/types';
import { reloadAuthToken } from '../../helpers/auth/reloadAuthToken';

export async function handleExistingCartId(authAtomState: AuthDetails | null): Promise<void> {
  try {
    if (!authAtomState?.publicCsrf) {
      await reloadAuthToken();
    }

    await fetchCart();
  } catch (error) {
    logger.error('Error handling existing cart ID:', error);
    throw error;
  }
}
